import React, { useContext } from "react"
import * as styles from "./mailForm.module.css"
import { injectIntl, FormattedMessage } from "gatsby-plugin-intl"
import MyContext from "../context/StateContext.js"

const MailForm = ({ isAfter, intl }) => {
  const { updateSubscribeOpen } = useContext(MyContext)
  return (
    <div className={styles.formContainer}>
      <div className={styles.mailForm}>
        <p className={styles.headerText}>
          <FormattedMessage id="form_head" />
        </p>
        <button
          type="button"
          onClick={() => updateSubscribeOpen(true)}
          className={isAfter ? styles.afterSubmit : styles.submit}
        >
          {intl.formatMessage({ id: "subscribe" })}
        </button>
      </div>
    </div>
  )
}

export default injectIntl(MailForm)
